import { useState } from 'react';
import type { TimeScope } from '#shared/types';
import { readPreference, writePreference } from '#client/lib/preferences';

export const SCOPES: TimeScope[] = ['today', 'week', 'month'];

/**
 * The dashboard's time scope, remembered per user: someone who works to a
 * weekly rhythm should not have to reselect it every morning.
 */
export function useDashboardScope(userId: number | undefined) {
  const [scope, setScopeState] = useState<TimeScope>(() =>
    readPreference(userId, 'dashboard.scope', { allowed: SCOPES, fallback: 'today' }),
  );

  const setScope = (next: TimeScope) => {
    setScopeState(next);
    writePreference(userId, 'dashboard.scope', next);
  };

  return [scope, setScope] as const;
}
